<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h3>Account Settings</h3>
        
        <!-- Other profile settings would go here -->
        
        <!-- Two-Factor Authentication Section -->
        <div class="mt-4">
          <two-factor-settings />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TwoFactorSettings from '@/components/auth/TwoFactorSettings.vue'

export default {
  name: 'ProfileView',
  components: {
    TwoFactorSettings
  }
}
</script>